<template>
  <div>
    <app-form
      v-bind:parentObject="{
        data: this.formData,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        errMsg: this.errMsg,
        isEdit: this.editMode,
      }"
      v-on:input="formData = $event"
    />
    <div v-if="isErr">
      <app-error
        v-bind:parentError="{
          data: this.errMsg,
          isErr: this.isErr,
        }"
        v-on:closeError="isErr = $event"
      />
    </div>
  </div>
</template>

<script>
import GridForm from "../../../components/attendance/staffdailyroster/Import";
import ErrorDialogue from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": GridForm,
    "app-error": ErrorDialogue,
  },

  data() {
    return {
      pageTitle: this.$t('staffdailyrosterimport'),
      pageTitleValue: "",
      formData: {},
      errMsg: "",
      isErr: false,
      editMode: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },
  },
};
</script>
